<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-md-6" v-if="statistics">
        <div class="row">
          <div class="col-xl-6" v-if="statistics.objectives.length > 0">
            <objective-widget v-for="objective in statistics.objectives" :key="objective.id"
                              :objective="objective"></objective-widget>
          </div>
          <div class="col-xl-12" v-else>
            <div class="card-box tilebox-three">
              Il n'y a pas d'objectifs associés à votre compte.
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="statistics">
        <planning-widget v-if="statistics.user.default_week_planning"
                         :planning="statistics.user.default_week_planning"></planning-widget>
        <div v-else>
          <div class="card-box tilebox-three">
            Il n'y a pas de planning associé à votre compte.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ObjectiveWidget from './Dashboard/ObjectiveWidget'
  import PlanningWidget from './Dashboard/PlanningWidget'

  export default {
    name: 'dashboard',
    components: {PlanningWidget, ObjectiveWidget},
    computed: {
      statistics () {
        return this.$store.getters['user_statistics/current']
      }
    },
    activated () {
      this.$store.commit('app/ui/changeTitle', 'Tableau de Bord')
      this.$store.commit('app/ui/changeSubtitle', 'Bienvenue sur votre interface commerciale.')
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?70e93d4f